import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as stationSearchActions from '../stationSearch/stationSearchActions';
import * as productSearchActions from './productSearchActions';
import StationSearchContainer from '../stationSearch/StationSearchContainer';
import {PSEUDO_CITY} from '../productSearch/stationTypeConstants';
import i18n from 'i18next';
import translations from "../translations";

i18n.init({
  lng: window.Flyblade.locale,
  resources: translations
});

class OriginSearchContainer extends Component {

  constructor(props) {
    super(props);
    this.searchStations = _.debounce(this.searchStations.bind(this), 300);
    this.selectResultAndClose = this.selectResultAndClose.bind(this);
    this.back = this.back.bind(this);
  }

  componentDidMount() {
    $('#key-routes').hide();
    this.executeSearch('');
  }

  searchStations(event) {
    this.executeSearch(event.target.value);
  }

  executeSearch(query) {
    this.props.actions.searchOrigins(query, true, this.props.suggested_stations, this.props.destination_selections);
  }

  selectResultAndClose(station_result) {
    $('#key-routes').show();
    this.props.actions.selectOrigins(station_result);
    this.back();
  }

  back() {
    this.props.actions['open' + this.props.back]();
  }

  buildWithScheduledServiceHeader() {
    let result = this.props.destination_station_result;
    if (result) return 'Scheduled, Charter, Crowdsource to ' + result.code;
  }

  buildSuggestedHeader() {
    let result = this.props.destination_station_result;
    if (result) {
      return i18n.t('originSearch.suggestedCharter') + result.code;
    } else {
      return i18n.t('originSearch.suggested')
    }
  }

  getOppositeDirectionCode() {
    let result = this.props.destination_station_result;
    if (result) return result.code;
  }

  render() {
    return (
      <StationSearchContainer
        label={i18n.t('originSearch.label')}
        searchStations={this.searchStations}
        cancelSearch={this.back}
        selectStationResult={this.selectResultAndClose}
        oppositeDirectionCode={this.getOppositeDirectionCode()}
        suggested={{showPopular: false}}
        placeholder={i18n.t('originSearch.placeholder')}
        withScheduledServiceHeader={this.buildWithScheduledServiceHeader()}
        suggestedHeader={this.buildSuggestedHeader()}
        pointDescription={i18n.t('originSearch.origins')}
      />
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    back: state.productSearch.origin_search_container.back,
    suggested_stations: state.productSearch.suggested_stations,
    destination_selections: state.productSearch.destination_selections,
    destination_station_result: state.productSearch.destination_station_result
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...stationSearchActions, ...productSearchActions}, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OriginSearchContainer)
